const host = `https://api.airdna.co`
const accessToken = `8d90cd0eebe44e05b2b6d6590e842b27`

export const getAPI = (address,lat,lng,bedrooms,bathrooms)=>{
    console.log(address,lat,lng,bedrooms,bathrooms)
    return `${host}/client/v1/rentalizer/estimate?access_token=${accessToken}&address=${address}&bedrooms=${bedrooms}&bathrooms=${bathrooms}&accommodates=6&currency=usd&lat=${lat}&lng=${lng}&show_urls=True`
}